/**
 * Iframe-safe blob indirme yardımcıları.
 *
 * Admin panel spine app içinde iframe olarak embed edildiğinden, bazı
 * tarayıcılarda `<a download>` iframe sandbox'ında bloklanır. Bu yüzden önce
 * parent'a postMessage ile devretmeyi dener (parent dinliyorsa top window'da
 * indirir), ayrıca iframe'in kendi `<a download>` denemesini de yapar.
 *
 * Bu mantık ilk olarak Leaderboard/index.jsx içinde yazılmıştı; görev detay
 * export'ları (Madde 2) da aynı davranışa ihtiyaç duyduğu için ortak util'e
 * çıkarıldı.
 */
import { postToParent } from './iframe';

const XLSX_MIME =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/**
 * Axios response payload'ını (Blob | ArrayBuffer | diğer) güvenli şekilde
 * Blob'a normalize eder.
 */
export function normalizeToBlob(payload, mime = XLSX_MIME) {
  if (payload instanceof Blob) return payload;
  if (payload instanceof ArrayBuffer) return new Blob([payload], { type: mime });
  return new Blob([payload], { type: mime });
}

/** `<a download>` click pattern — iframe-safe. */
function triggerDownload(url, filename) {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  // Bazı tarayıcılarda anchor hemen kaldırılırsa indirme iptal olabilir.
  setTimeout(() => {
    if (a.parentNode) a.parentNode.removeChild(a);
  }, 100);
}

/**
 * Bir Blob'u dosya olarak indirir. Iframe içindeyse parent'a da `download:file`
 * postlar (parent dinliyorsa top window'dan indirir).
 *
 * @returns {boolean} true — indirme tetiklendi
 * @throws boş blob veya tarayıcı izin hatası durumunda Error
 */
export function downloadBlob(payload, filename, mime = XLSX_MIME) {
  const blob = normalizeToBlob(payload, mime);
  if (!blob || blob.size === 0) {
    throw new Error('İndirilecek içerik boş.');
  }

  const isInIframe = (() => {
    try {
      return window.top !== window.self;
    } catch {
      // Cross-origin top → iframe'iz; postMessage yine çalışır.
      return true;
    }
  })();

  if (isInIframe) {
    try {
      const parentUrl = URL.createObjectURL(blob);
      postToParent('download:file', { url: parentUrl, filename });
      triggerDownload(parentUrl, filename);
      setTimeout(() => URL.revokeObjectURL(parentUrl), 5000);
      return true;
    } catch {
      // postMessage/URL hatası → aşağıdaki normal indirmeye düş.
    }
  }

  const url = URL.createObjectURL(blob);
  triggerDownload(url, filename);
  setTimeout(() => URL.revokeObjectURL(url), 5000);
  return true;
}
